import { c as _c } from "react/compiler-runtime";
import { useEventListener } from 'usehooks-ts';

// Coming back from an external sign-in through the back/forward cache restores the page with its React
// state intact, so a CTA left in its busy state would stay that way until a hard reload.
const useResetOnPageRestore = reset => {
  const $ = _c(2);
  let t0;
  if ($[0] !== reset) {
    t0 = event => {
      if (event.persisted) {
        reset();
      }
    };
    $[0] = reset;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEventListener("pageshow", t0);
};
export default useResetOnPageRestore;